import i18n from '@/i18n';

// The app's base/brand title. Shown on `/` and whenever nothing more specific
// applies (e.g. a detail page whose item is still loading or has no name).
export const BASE_TITLE = 'Tehnik';

/**
 * Set `document.title` to an explicit, already-resolved string — a loaded
 * item's name (`/page/id`) or a pre-translated label. Blank/empty falls back
 * to the base title. Detail views call this once their data has loaded.
 */
export function setDocumentTitle(text) {
    const value = text == null ? '' : String(text).trim();
    document.title = value || BASE_TITLE;
}

/**
 * Resolve a route's title from its `meta.titleKey` (an i18n key) in the current
 * locale, falling back to the base title. Used by the global router guard for
 * static and list pages (`/` and `/page`). Detail views override this after
 * they fetch their item.
 */
export function setTitleFromRoute(route) {
    const { t, te } = i18n.global;
    const key = route?.meta?.titleKey;
    setDocumentTitle(key && te(key) ? t(key) : '');
}
